import axios from "axios";
import {
  AppConfiguration,
  AppConfigurationKey,
  BannerDto,
  CreateAppConfigCommand,
  UpdateAppConfigCommand,
} from "./models/AppConfiguration";

export const getAppConfigForBanner = async (): Promise<BannerDto[]> => {
  const { data } = await axios.get<BannerDto[]>(
    `${window.configuration.apiUrl}api/AppConfiguration/${AppConfigurationKey.Banner}`
  );

  return data;
};

export const updateAppConfig = async (
  appConfig: UpdateAppConfigCommand
): Promise<AppConfiguration> => {
  const { data } = await axios.put<AppConfiguration>(
    `${window.configuration.apiUrl}api/AppConfiguration/${appConfig.id}`,
    appConfig
  );
  return data;
};

export const createAppConfig = async (
  appConfig: CreateAppConfigCommand
): Promise<boolean> => {
  await axios.post<CreateAppConfigCommand>(
    `${window.configuration.apiUrl}api/AppConfiguration`,
    appConfig
  );
  return true;
};

export const deleteBannerConfig = async (id: string): Promise<void> => {
  await axios.delete(
    `${window.configuration.apiUrl}api/AppConfiguration/${id}`
  );
};
